export enum DiscussionTabs {
  Chat = 0,
  PinnedMessages = 1,
  UserMentions = 2,
  UserNudges = 3,
  Suggestions = 4,
}
